module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1344645"
    }
  }, [_c('b', [_vm._v("CUBANO QUESADILLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1345145"
    }
  }, [_c('b', [_c('i', [_vm._v("Our take on the classic pressed sandwich adds a touch of the Southwest. Low-fat tortillas make for a lighter bite with all the flavor of the original.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1346445"
    }
  }, [_c('b', [_vm._v("Prep: 18 minutes       Cook: 2 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1346945"
    }
  }, [_vm._v("8 (6-inch) low-fat tortillas")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1347245"
    }
  }, [_vm._v("¼ cup yellow mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1348145"
    }
  }, [_vm._v("4 ounces thinly sliced Black Forest ham")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1348445"
    }
  }, [_vm._v("8 sandwich-cut dill pickle slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1348845"
    }
  }, [_vm._v("4 ounces thinly sliced roast pork from the deli")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1349145"
    }
  }, [_vm._v("4 ounces thinly sliced part-skim Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1349645"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Prepare outdoor grill for directly grilling over medium heat.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1350645"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Brush 1 side of each tortilla with mustard. Evenly divide ham, pickles, pork, and cheese between 4 tortillas, placing them on top of mustard. Top with remaining tortillas, mustard side down, pressing firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1352545"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v("With large metal spatula, place quesadillas on hot grill grate and cook 2 to 3 minutes or until tortillas on both sides are browned and Swiss cheese melts, carefully turning quesadillas once. Transfer quesadillas to large cutting board; let stand 1 minute. Cut each quesadilla into 4 wedges to serve. Makes 8 appetizer servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1355145"
    }
  }, [_vm._v("Each serving (2 wedges) : About 190 calories, 15g protein, 18g carbohydrate, 6g total fat (2g saturated), 1g fiber, 27mg cholesterol, 640mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0045_001",
      "src": "Images/9781618371621_0045_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1356645"
    }
  }, [_vm._v("Cubano Quesadillas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d4b384","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c36_r1.vue
// module id = 174
// module chunks = 0